import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AuthForm from "./AuthForm";
import App from "./App";
import Navbar from "./components/Navbar";
import Pricing from "./pages/Pricing";
import FAQ from "./pages/FAQ";
import Upgrade from "./pages/Upgrade";
import MekFundedClaimPage from "./pages/MekFundedClaimPage";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import ComingSoon from "./pages/ComingSoon";
import { useContext } from "react";
import { AuthContext } from "./AuthContext";


function ProtectedRoute({ children }) {
  const { token } = useContext(AuthContext);
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function MainRoutes() {
  const COMING_SOON = process.env.REACT_APP_COMING_SOON === 'true';
  if (COMING_SOON) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<ComingSoon />} />
        </Routes>
        <WhatsAppFloat />
      </BrowserRouter>
    );
  }
  return (
    <BrowserRouter>
      <Navbar />
      <div className="pt-[80px]">
        <Routes>
          {/* Public Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/upgrade" element={<Upgrade />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/faq" element={<FAQ />} />

          {/* Auth */}
          <Route path="/login" element={<AuthForm />} />
          <Route path="/signup" element={<AuthForm />} />
          <Route path="/claim/mekfunded" element={<MekFundedClaimPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
           
           {/* Dashboard (protected) */}
          <Route path="/app/*" element={
            <ProtectedRoute>
              <App />
            </ProtectedRoute>
          } />
        </Routes>
        <Footer />
      </div>
      <WhatsAppFloat />
    </BrowserRouter>
  );
}

export default MainRoutes;